import {
    Avatar,
    Button,
    Card, CardActions, CardContent, CardHeader,
    Divider,
    Link,
    Table, TableBody, TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import axios from "axios";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    actions: {
        justifyContent: 'flex-end'
    },
    contentSection: {
        padding: '16px 22px',
        background: '#fff',
        marginBottom: '15px',
        borderRadius: '3px',
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionHeaderTitle: {
        fontSize: '17px',
        fontWeight: '600',
        color: '#000',
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    form: {
        height: '100%',
    },
    field: {
        '& label.Mui-focused': {
            color: '#000',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#000',
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: '#000',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#000',
            },
        },
    },
    tabActive: {
        color: '#1E69E5',
    },
    associationLink: {
        position: 'absolute',
        top: '-10px',
        right: '10px',
        cursor: 'pointer',
        decoration: 'none',
        '&:hover': {
            decoration: 'none',
        }
    },
    inheritFontWeight: {
        fontWeight: 'inherit',
    },
    tableMarginTop: {
        marginTop: 24,
    },
}));

const ContactsAccoladesSectionAddModal = (props) => {
    const classes = useStyles()
    const {contact, onClose, adminUserSession} = props
    const [accolades, setAccolades] = useState([])

    useEffect(() => {
        getAccolades()
    }, [])

    const getAccolades = () => {
        const crdId = contact.contact_crd_id
        axios.get(
            '/v1/admin/contacts_accolades/accolades_by_crd_id',
            {
                params: {crd_id: crdId, exclude: true},
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': adminUserSession.email,
                    'X-Admin-User-Token': adminUserSession.token
                }
            }
        ).then((response) => {
            const {accolades} = response.data;
            setAccolades(accolades)
        });
    }

    const headCells = [
        {id: 'id', label: 'Id'},
        {id: 'logo', label: 'Logo'},
        {id: 'outlet', label: 'Outlet'},
        {id: 'description', label: 'Accolade'},
        {id: 'year', label: 'Year'},
        {id: 'crd_ids', label: 'Associated Contacts'},
    ];

    const handleAddItem = (event, id) => {
        const crdId = contact.contact_crd_id
        axios.put(
            '/v1/admin/contacts_accolades/update_crd_ids',
            {
                params: {id: id, crd_id: crdId},
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Admin-User-Email': adminUserSession.email,
                    'X-Admin-User-Token': adminUserSession.token
                }
            }
        ).then((response) => {
            onClose()
        });
    }

    const renderRow = (props) => {
        return (
            <TableRow key={props.id}>
                <TableCell>{props.id}</TableCell>
                <TableCell>
                    <Avatar src={props.logo.url}
                            alt={props.outlet}>{props.outlet?.[0]}
                    </Avatar>
                </TableCell>
                <TableCell>{props.outlet}</TableCell>
                <TableCell>{props.description}</TableCell>
                <TableCell>{props.year}</TableCell>
                <TableCell>{props.crd_ids ? props.crd_ids.length : 0}</TableCell>
                <TableCell>
                    <Link to='' onClick={(event) => handleAddItem(event, props.id)}>Add</Link>
                </TableCell>
            </TableRow>
        )
    }

    return (
        <React.Fragment>
            <Card
                className={clsx(classes.root)}
            >
                <CardHeader accolade='Accolade'/>
                <Divider/>
                <CardContent>
                    {accolades ? <Table className={classes.tableMarginTop}>
                        <TableHead>
                            <TableRow>
                                {headCells.map((headCell) => (
                                    <TableCell key={headCell.id}>
                                        {headCell.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {accolades == undefined ?
                                <TableRow><TableCell>Loading...</TableCell></TableRow> : accolades.map(renderRow.bind(this))}
                        </TableBody>
                    </Table> : null}
                </CardContent>
                <Divider/>
                <CardActions>
                    <Button onClick={onClose}>Close</Button>
                </CardActions>
            </Card>
        </React.Fragment>
    )
}

export default ContactsAccoladesSectionAddModal;